import SavedCartsCollection from '../collections/savedCarts';

export const allSavedCarts = new SavedCartsCollection([], {
	pager: {pageSize: 0x7fffffff},
});

export const favoriteSavedCarts = new SavedCartsCollection([], {
	pager: {pageSize: 0x7fffffff, pagesToDisplay: 0},
	modeFilters: ['favorites'],
});

allSavedCarts
	.on(
		'add',
		(model) => model.isFavorite() && favoriteSavedCarts.add(model.attributes),
	)
	.on('destroy', (model) => favoriteSavedCarts.remove(model.id));

export default {allSavedCarts, favoriteSavedCarts};
